// TaskList.js - Eine separate Komponente zur Anzeige der Aufgabenliste
import React from 'react';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorAlert from '../common/ErrorAlert';
import Button from '../common/Button';

/**
 * Komponente zur Anzeige einer Liste von Aufgaben
 * 
 * @param {Object} props - Komponenteneigenschaften
 * @param {Array} props.tasks - Die anzuzeigenden Aufgaben
 * @param {boolean} props.loading - Loading-Status
 * @param {string|null} props.error - Fehlermeldung
 * @param {Function} props.onEditTask - Callback für das Bearbeiten einer Aufgabe
 */
const TaskList = ({ tasks, loading, error, onEditTask }) => {
  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <ErrorAlert error={error} />;
  }

  return (
    <div className="bg-white rounded-lg shadow">
      <table className="min-w-full">
        <thead>
          <tr className="bg-[#FCFCFC]" style={{ borderBottom: "1px solid #EFEFF0" }}>
            <th className="pl-[32px] text-left text-primary">Name</th>
            <th className="p-2 text-left text-primary">Stundensatz</th>
            <th className="p-2 text-left text-primary">Tagessatz</th>
            <th className="p-2 text-right text-primary">Aktionen</th>
          </tr>
        </thead>
        <tbody className="bg-[#FCFCFC]">
          {tasks.map((task) => (
            <tr key={task._id}>
              <td className="pl-[32px] font-bold">{task.name}</td>
              <td className="p-2">{task.hourlyRate || 'N/A'}</td>
              <td className="p-2">{task.dailyRate || 'N/A'}</td>
              <td className="p-2 text-right">                                <Button
                                            variant="light" 
                                            size="sm"
                                            className="text-primary hover:text-primaryDark"
                                            onClick={() => onEditTask(task)}
                                        >
                                            Bearbeiten
                                        </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TaskList;
